import api from '@/services/api/client';

export type UnplugEventType = 'unplugged' | 'plugged';

export type UnplugEvent = {
  id: number;
  vehicleId: number;
  registrationNumber: string;
  organizationName: string;
  eventType: UnplugEventType;
  occurredAt: string;
  lat: number | null;
  lng: number | null;
  imei: string | null;
  address?: string | null;
  emailSentAt: string | null;
};

export async function fetchUnplugEvents(params: {
  from: string;
  to: string;
  organizationId?: string;
  eventType?: UnplugEventType | '';
  registrationNumber?: string;
  limit?: number;
  offset?: number;
}): Promise<{ rows: UnplugEvent[]; total: number }> {
  const response = await api.get('/api/vehicles/unplug-events', {
    params: {
      from: params.from,
      to: params.to,
      organizationId: params.organizationId || undefined,
      eventType: params.eventType || undefined,
      registrationNumber: params.registrationNumber || undefined,
      limit: params.limit ?? 50,
      offset: params.offset ?? 0,
    },
  });
  if (!response.data?.success) {
    throw new Error(response.data?.error || 'unplug events failed');
  }
  return {
    rows: (response.data.data ?? []) as UnplugEvent[],
    total: Number(response.data.meta?.total || 0),
  };
}
